import { useRouter } from "next/router";
import React from "react";
import Header from "./Header/Header";
import Head from "next/head";

export default function Layout({ pagesData, children }) {
  const router = useRouter();
  const pathname = router.pathname;
  const query = router.query;
  const pathsVariableHeightLayout = [
    /^\/$/,
    /\/project/,
    /^\/figures$/,
    /^\/locations$/,
    /^\/locations\/memorials/,
  ];

  const useVariableHeightLayout = (pathname) => {
    let res = false;

    pathsVariableHeightLayout.forEach((regex) => {
      if (regex.test(pathname)) res = true;
    });

    // map view of locations index page
    if (pathname === "/locations" && query.view === "map") {
      res = false;
    }

    return res;
  };

  const isVariableHeightLayout = useVariableHeightLayout(pathname);

  const title = "Chronotopos Romantik";
  const description = "Chronotopos Romantik - Recherchestation";
  const baseUrl = "https://chronotopos-romantik.freies-deutsches-hochstift.de";
  const currentUrl = `${baseUrl}${router.asPath}`;

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta property="og:title" content={title} key="title" />
        <meta
          name="keywords"
          content="Recherchestation, FDH, Freies Deutsches Hochstift, Romantik, Romantikmuseum, Frankfurt, Goethe, Chamisso, Beethoven, Interaktive Landkarte, Chronotopos Romantik"
        />
        <meta name="description" content={description} />
        <meta name="author" content="MESO Digital Interiors GmbH" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

        {/* Favicon */}
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/favicons/apple-touch-icon.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/favicons/favicon-32x32.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="/favicons/favicon-16x16.png"
        />
        <link rel="manifest" href="/favicons/site.webmanifest" />
        <link rel="shortcut icon" href="/favicons/favicon.ico" />
        <meta name="msapplication-TileColor" content="#fcfaf7" />
        <meta name="theme-color" content="#fcfaf7" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:domain" content={baseUrl} />
        <meta property="twitter:url" content={baseUrl} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={`${baseUrl}/preview.png`} />

        {/* Open Graph */}
        <meta property="og:title" content={title} key="ogtitle" />
        <meta property="og:url" content={currentUrl} key="ogurl" />
        <meta property="og:image" content={`${baseUrl}/preview.png`} key="ogimage" />
        <meta property="og:site_name" content={title} key="ogsitename" />
        <meta property="og:description" content={description} key="ogdesc" />
      </Head>
      <div className="main h-full flex flex-col">
        <Header data={pagesData} />
        <div className={`w-full flex ${isVariableHeightLayout ? null : "h-full"}`}>
          <div className="sides"></div>
          {isVariableHeightLayout ? (
            <div className="bg-white w-full h-auto p-3 lg:p-10 pt-4 xl:pt-16 relative">
              {children}
            </div>
          ) : (
            <div className="h-full w-full bg-alpha relative">{children}</div>
          )}
          <div className="sides"></div>
        </div>
      </div>
    </>
  );
}
